<template>
    <div class="ts_order receivable-receipt">
        <div class="detail_header">
            <div class="title">查看</div>
            <div class="detail_header_button">
                <el-button @click="close()">取消</el-button>
            </div>
        </div>
        <div class="detail_body">
            <el-form inline label-width="100px">
                <el-form-item label="客户名称：">
                    <span>{{ dataObj.custName }}</span>
                </el-form-item>
                <el-form-item label="客户抬头：">
                    <span>{{ dataObj.accountName }}</span>
                </el-form-item>
                <el-form-item label="创建人：">
                    <span>{{ dataObj.userName }}</span>
                </el-form-item>
                <el-form-item label="创建日期：">
                    <span>{{ dataObj.gmtCreate.split(' ')[0] }}</span>
                </el-form-item>
                <el-form-item label="付款方式：">
                    <span>{{ dataObj.settleName }}</span>
                </el-form-item>
            </el-form>
            <el-table :data="dataObj.confirmList" class="receivable-order">
                <el-table-column label="单据类型" prop="type" width="100"/>
                <el-table-column label="出库日期" prop="deliveryTime" width="100"/>
                <el-table-column label="采购订单编号" prop="saleOrderNo" width="150"/>
                <el-table-column label="物品编号" prop="goodsNo" width="160"/>
                <el-table-column label="客户品名/色号" prop="custArtAndColor"/>
                <el-table-column label="款号" prop="modelNumber"/>
                <el-table-column label="单价" prop="price" width="60"/>
                <el-table-column label="结算数量" prop="quantity" width="80"/>
                <el-table-column label="附加费" prop="additionalFee" width="70"/>
                <el-table-column label="总金额" prop="totalFee" width="70"/>
                <el-table-column label="收款金额" prop="amount" width="80"/>
                <el-table-column label="截止日期" prop="expiryDate" width="100"/>
                <el-table-column label="报关发票号" prop="invoiceNo"/>
                <el-table-column label="备注" prop="remark"/>
            </el-table>
        </div>
    </div>
</template>

<script>
    import ReconciliationChecklist from '../../../bean/order/ReconciliationChecklist';
    import checkOrder from '@/mixins/order/common/CheckOrder';
    import ReconciliationChecklistMixin from '../../../mixins/order/ReconciliationChecklistMixin'

    export default {
        name: 'DetailReconciliationChecklist',
        mixins: [checkOrder, ReconciliationChecklistMixin],
        ts: {
            pageType: 'modify',
            order: {
                ...ReconciliationChecklist
            }
        },
        data() {
            return {
                dataObj: {}
            };
        },
        methods: {
            async setDefaultValue() {
                const { data } = await this.qGet(`/sales/reconciliation_order/${this.$route.params.id}`);
                if (data) {
                    this.dataObj = {
                        ...data
                    };
                }
            }
        }
    }
</script>

<style lang="scss">
    .detail_header {
        padding-top: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
            font-size: 14px;
            color: #8497B3;
        }
    }
    .detail_header_button {
        display: flex;
        &.padding-10 {
            padding: 10px 0 0 0;
        }
        .el-button {
            width: 100px;
        }
    }
    .detail_body {
        padding-top: 15px;
    }
</style>
